import { AuthState } from '@okta/okta-auth-js';

import { CompuweighMassCreates } from '../../services/backend/CompuweighMassCreates';
import { useBaseApiClient } from '../useBaseApiClient';

export const useCompuweighMassCreates: () => CompuweighMassCreates<AuthState> = () => {
  return useBaseApiClient(CompuweighMassCreates);
};
